import { ReactNode } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIconV2, MBIconV2Name } from '@shared/components/image';
import { grid } from '@shared/styles';
import styles from './RowContent.module.css';

const DEFAULT_ICON_SIZE = grid(3);

export interface RowContentProps {
  children?: ReactNode;
  label?: ReactNode;
  numberOfLines?: number;
  startContent?: ReactNode;
  // none shows an empty space next to the label, so it can align with other
  // menu items that have icons
  icon?: MBIconV2Name | 'none';
  iconSize?: number;
  endContent?: ReactNode;
  danger?: boolean;
  inactive?: boolean;
  disabled?: boolean;
}

export function RowContent({
  label,
  numberOfLines = 1,
  children,
  icon,
  iconSize = DEFAULT_ICON_SIZE,
  startContent,
  inactive,
  endContent,
  danger,
  disabled,
}: RowContentProps) {
  const showStartContent = icon || startContent;
  return (
    <>
      {showStartContent && (
        <View
          className={[
            styles.startContent,
            icon && styles.icon,
            danger && styles.danger,
            disabled && styles.disabled,
          ]}
          data-start-content
          data-icon={!!icon}
        >
          {icon && icon !== 'none' && <MBIconV2 name={icon} size={iconSize} />}
          {!icon && startContent}
        </View>
      )}
      {label && (
        <View className={[styles.label, danger && styles.danger]} data-label>
          <Text
            numberOfLines={numberOfLines}
            size="body1"
            danger={danger}
            inactive={inactive || disabled}
            data-label-text
          >
            {label}
          </Text>
        </View>
      )}
      {!label && children}
      {endContent && (
        <View className={[styles.endContent, danger && styles.danger]} data-end-content>
          {endContent}
        </View>
      )}
    </>
  );
}
